'use client';

import {
  CatSegmentedControl,
  CatSegmentedControlItem
} from 'components/blocks-components';
import { useTranslations } from 'next-intl';
import { useCallback, useState } from 'react';

export interface SavedListControlProps {
  params: {
    isSelfShoppingList?: boolean;
    isFavorite?: boolean;
  };
  hasOwnLists: boolean;
  hasFavoriteLists: boolean;
  setParams: (arg: Query) => void;
  isCspUser: boolean;
}

export const SavedListControl = ({
  params,
  hasOwnLists,
  hasFavoriteLists,
  setParams,
  isCspUser
}: Readonly<SavedListControlProps>) => {
  const t = useTranslations();
  const getCurrentTab = useCallback(() => {
    if (params.isSelfShoppingList) {
      return 0;
    }
    if (!isCspUser || !params.isFavorite) {
      return 1;
    }

    return 2;
  }, [params, isCspUser]);

  const [activeTab, setActiveTab] = useState(getCurrentTab());

  const tabs = [
    {
      id: 'myList',
      translationKey: 'QO_SAVEDLISTS_MYLIST',
      onClick: () => setParams({ isSelfShoppingList: true }),
      disabled: !hasOwnLists && isCspUser
    },
    ...(isCspUser
      ? [
          {
            id: 'allList',
            translationKey: 'QO_SAVEDLISTS_ALLLIST',
            onClick: () => setParams({ isSelfShoppingList: false }),
            disabled: false
          }
        ]
      : []),
    {
      id: 'favorite',
      translationKey: 'QO_SAVEDLISTS_FAV',
      onClick: () => setParams({ isFavorite: true }),
      disabled: !hasFavoriteLists
    }
  ];

  return (
    <CatSegmentedControl
      activeIndex={activeTab}
      onBlSegmentItemChange={(e) => {
        setActiveTab(e.detail.activeIndex);
        tabs[e.detail.activeIndex].onClick();
      }}
    >
      {tabs.map((eachTab) => (
        <CatSegmentedControlItem key={eachTab.id} disabled={eachTab.disabled}>
          {t(eachTab.translationKey)}
        </CatSegmentedControlItem>
      ))}
    </CatSegmentedControl>
  );
};
